<template>
  <v-main style="min-height: 70vh"> </v-main>
</template>

<script>
export default {
  name: "CandidateAccount",
  components: {},
  created() {
    this.$router.push({
      name: "CandidateMyJobResearch",
    });
  },
};
</script>

<style scoped></style>
